export default __webpack_public_path__ + "static/media/info_premium_image.a9867874.webp";